import { PropsWithChildren } from 'react';

import { theme } from '@actualtysoft/design-tokens';
import { ThemeProvider, createTheme } from '@mui/material';

const MaterialThemeProvider = ({ children }: PropsWithChildren<unknown>) => {
  const designSystemTheme = theme('Interne', 'light');
  const muiTheme = createTheme({
    cssVariables: {
      disableCssColorScheme: true,
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(designSystemTheme as any),
  });

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default MaterialThemeProvider;
